import React from 'react';
import { Grid } from '@mui/material';
import SparkStepsContainer from './SparkStepsContainer';
import SparkBuilderSideNav from './SparkBuilderDrawers/SparkBuilderSideNav';
import RightDrawerContainer from './SparkBuilderDrawers/RightDrawer/RightDrawerContainer';
import SparkStepsLoader from './SparkStepsLoader';
import { useSparkStepTypes } from 'hooks/EntityTypes/useSparkStepTypes';
import { useSparkBuilderStore } from 'stores';
import { useParams } from 'react-router-dom';
import { useSparkStepsBySparkID } from 'hooks/SparkBuilder/sparkStep';

function CreateSparkContainer({ headerHeight }: { headerHeight: number }) {
  const { id: sparkID = null } = useParams();

  const selectedStep = useSparkBuilderStore(
    (store) => store.builderSideBar.selectedStep
  );
  const { isLoading: isSparkStepLoading } = useSparkStepsBySparkID(sparkID);

  const { isLoading: isLoadingSparkStepTypes } = useSparkStepTypes();

  const isLoading = isLoadingSparkStepTypes || isSparkStepLoading;

  return (
    <Grid item bgcolor={(theme) => theme.palette.bgGray.light} marginTop='4rem'>
      <>
        {isLoading ? (
          <SparkStepsLoader />
        ) : (
          <>
            <SparkBuilderSideNav />
            <SparkStepsContainer />
            <RightDrawerContainer
              open={!!selectedStep && selectedStep.type !== 'noStepSelected'}
              headerHeight={headerHeight}
            />
          </>
        )}
      </>
    </Grid>
  );
}

export default CreateSparkContainer;
